var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"min-width":"1400px","width":"100%","height":"64px","margin":"0 auto","display":"block"},attrs:{"src":"https://www.wenhua.com.cn/popwin/footer_wenhua.html","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }